<template>
  <div class="car">
    <div class="tyretextl">
      <div class="flt">
        Front left tyre
        <div class="flts1">Sector1:  {{ fll_temp }} °C </div>
        <div class="flts2">Sector2:  {{ flil_temp }} °C </div>
        <div class="flts3">Sector3:  {{ flir_temp }} °C </div>
        <div class="flts4">Sector4:  {{ flr_temp }} °C </div>
        <div class="brake_temp_t_fr">Brake temp: {{ brakeTemp_FL }} °C</div>
      </div>
      <div class="rlt">
        Rear left tyre
        <div class="rlts1">Sector1:  {{ rll_temp }} °C </div>
        <div class="rlts2">Sector2:  {{ rlil_temp }} °C </div>
        <div class="rlts3">Sector3:  {{ rlir_temp }} °C </div>
        <div class="rlts4">Sector4:  {{ rlr_temp }} °C </div>
        <div class="brake_temp_t_fr">Brake temp: {{ brakeTemp_RL }} °C</div>
      </div>
    </div>
    
    <Tyre
      class="fr"
      :tempInnerLeft="fril_temp"
      :tempInnerRight="frir_temp"
      :tempLeft="frl_temp"
      :tempRight="frr_temp"
    /> 
    
    <Tyre
      class="fl"
      :tempInnerLeft="flil_temp"
      :tempInnerRight="flir_temp"
      :tempLeft="fll_temp"
      :tempRight="flr_temp"
    /> 
    <Tyre
      class="rr"
      :tempInnerLeft="rril_temp"
      :tempInnerRight="rrir_temp"
      :tempLeft="rrl_temp"
      :tempRight="rrr_temp"
    />
    <Tyre
      class="rl"
      :tempInnerLeft="rlil_temp"
      :tempInnerRight="rlir_temp"
      :tempLeft="rll_temp" 
      :tempRight="rlr_temp"
    />
    <BrakeTemp class="brake_temp_car "
      :brakeTempFR="brakeTemp_FR" 
      :brakeTempRR="brakeTemp_RR" 
      :brakeTempFL="brakeTemp_FL" 
      :brakeTempRL="brakeTemp_RL" 
    />
    <Drs class="wing" :class="getDrsClass" />
    
    
    <div class="tyretextr">
      <div class="frt">
        
        Front right tyre
        <div class="frts1">Sector1:  {{ frl_temp  }} °C </div>
        <div class="frts2">Sector2:  {{ fril_temp }} °C </div>
        <div class="frts3">Sector3:  {{ frir_temp }} °C </div>
        <div class="frts4">Sector4:  {{ frr_temp }} °C </div>
        <div class="brake_temp_t_fr">Brake temp: {{ brakeTemp_FR }} °C</div>
      </div>
      <div class="rrt">
        Rear right tyre
        <div class="rrts1">Sector1:  {{ rrl_temp }} °C</div>
        <div class="rrts2">Sector2:  {{ rril_temp }} °C </div>
        <div class="rrts3">Sector3:  {{ rrir_temp  }} °C </div>
        <div class="rrts4">Sector4:  {{ rrr_temp }} °C </div>
        <div class="brake_temp_t_fr">Brake temp: {{ brakeTemp_RR }} °C</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Tyre from '@/components/Tyre.vue';
import Drs from '@/components/Drs.vue';
import BrakeTemp from '@/components/BrakeTemp.vue';
import { computed } from 'vue';

const props = defineProps({
  // Front left tyre temperature
  flir_temp: {
    type: Number,
    required: true,
  },
  flil_temp: {
    type: Number,
    required: true,
  },
  flr_temp: {
    type: Number,
    required: true,
  },
  fll_temp: {
    type: Number,
    required: true,
  },

  // Front right tyre temperature
  frir_temp: {
    type: Number,
    required: true,
  },
  fril_temp: {
    type: Number,
    required: true,
  },
  frr_temp: {
    type: Number,
    required: true,
  },
  frl_temp: {
    type: Number,
    required: true,
  },

  // Rear left tyre temperature
  rlir_temp: {
    type: Number,
    required: true,
  },
  rlil_temp: {
    type: Number,
    required: true,
  },
  rlr_temp: {
    type: Number,
    required: true,
  },
  rll_temp: {
    type: Number,
    required: true,
  },

  // Rear right tyre temperature
  rrir_temp: {
    type: Number,
    required: true,
  },
  rril_temp: {
    type: Number,
    required: true,
  },
  rrr_temp: {
    type: Number,
    required: true,
  },
  rrl_temp: {
    type: Number,
    required: true,
  },

  drs: {
    type: Number,
    required: true,
  },
  brakeTemp_FR: {
    type: Number,
    required: true,
  },
  brakeTemp_RR: {
    type: Number,
    required: true,
  },
  brakeTemp_FL: {
    type: Number,
    required: true,
  },
  brakeTemp_RL: {
    type: Number,
    required: true,
  },
  
});

const getDrsClass = computed(()=>{
  return props.drs === 1 ? 'open' : 'closed';
})
</script>
